(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileBusinessUnitsController', Controller);

    Controller.$inject = ['$scope', '$q', '$timeout', '$state', 'govNotificationDelay', 'searchService', 'pagerService', 'biaProfileService', 'biaBuOwnerService'];

    function Controller($scope, $q, $timeout, $state, govNotificationDelay, searchService, pagerService, biaProfileService, biaBuOwnerService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.availableBusinessUnits = [];
        $scope.ctrlCtxt.canSelect = true;

        // Init Pager
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 6 });
        $scope.pager.updatePagerFromItems($scope.availableBusinessUnits);

        // Search Business Units
        $scope.searchBusinessUnits = function () {
            var searchTerm = $scope.ctrlCtxt.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableBusinessUnits = [];
                $scope.pager.updatePagerFromItems($scope.availableBusinessUnits);
                return;
            }

            searchService
                .searchBusinessUnits(searchTerm)
                .then(function (foundBUs) {
                    $scope.availableBusinessUnits = _.differenceBy(foundBUs, $scope.boxContext.BIABUOwners, 'BusinessUnitID');
                    $scope.pager.updatePagerFromItems($scope.availableBusinessUnits);
                });
        };

        $scope.selectBusinessUnit = function (bu) {
            if (_.isUndefined($scope.bIABUOwners)) $scope.bIABUOwners = [];
            $scope.bIABUOwners.push({ BIAProfileID: $scope.boxModel.BIAProfileID, BusinessUnitID: bu.BusinessUnitID, BusinessUnit: bu });
            $scope.availableBusinessUnits = _.reject($scope.availableBusinessUnits, { BusinessUnitID: bu.BusinessUnitID });
            $scope.ctrlCtxt.canSelect = !$scope.maxNbBiaBuOwner ||
                ($scope.maxNbBiaBuOwner > 0 && $scope.bIABUOwners.length < $scope.maxNbBiaBuOwner);
        };

        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form) {
            if (_.isUndefined(form)) return;
            if (form.$invalid) return true;

            return _.size($scope.bIABUOwners) === 0;
        };

        // Save Changes
        $scope.saveChanges = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError = false;
                }, govNotificationDelay);

                return;
            }

            var promiseChain = $q.when();
            if ($scope.onSave) {
                promiseChain.then($scope.onSave({
                    biaProfile: $scope.boxModel,
                    bIABUOwners: $scope.bIABUOwners
                }));
            } else {
                //TODO: Provider this function as onSave parameter
                // Chain BiaBUOwner Creations
                _.each($scope.bIABUOwners, function (biaBuOwnerToAdd) {
                    if (!_.isUndefined(biaBuOwnerToAdd.BusinessUnitID)) {
                        promiseChain = promiseChain
                        .then(function () {
                            return biaBuOwnerService
                                        .createBIABuOwner($scope.boxModel.BIAProfileID, biaBuOwnerToAdd);
                        });
                    }
                });
            }

            promiseChain.then(function () {
                $state.reload();
                $scope.close();
            });
        };
    }
})();
